export default "__VITE_ASSET__197e2e3e__"